export default __webpack_public_path__ + "static/media/trickHealthgenom.f411c19f.svg";